import { RepositoryFactory } from '../repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '../services/CredentialsService.js'

const TaskUserRespository = RepositoryFactory.get('taskUser')

class RiderService {
  static async getTaskUsers (params) {
    try {
      return await TaskUserRespository.getTaskUsers(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }
  static async createTaskUser (data) {
    try {
      return await TaskUserRespository.createTaskUser(CredentialsService.getCurrentTenantId(), data)
    } catch (error) {
      console.log(error)
      throw error
    }
  }
  static async createTaskUserList (data) {
    try {
      return await TaskUserRespository.createTaskUserList(CredentialsService.getCurrentTenantId(), data)
    } catch (error) {
      console.log(error)
    }
  }
  static async updateTaskUser (taskUserId, data) {
    try {
      return await TaskUserRespository.updateTaskUser(CredentialsService.getCurrentTenantId(), taskUserId, data)
    } catch (error) {
      console.log(error)
      throw error
    }
  }
  static async updateAllTaskUser (data) {
    try {
      return await TaskUserRespository.updateAllTaskUser(CredentialsService.getCurrentTenantId(), data)
    } catch (error) {
      console.log(error)
    }
  }
  static async deleteTaskUser (taskUserId) {
    try {
      return await TaskUserRespository.deleteTaskUser(CredentialsService.getCurrentTenantId(), taskUserId)
    } catch (error) {
      console.log(error)
    }
  }
  static async exportTaskUser (params) {
    try {
      return await TaskUserRespository.exportTaskUser(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }
  static async exportICADocuent (params) {
    try {
      return await TaskUserRespository.exportICADocuent(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }
}

export default RiderService
